import { useState } from 'react'

import { AssignCardModalProps } from './AssignCardModal.types'

// Services
import { useGetPreferenceCardsToBeAssigned } from 'lib/services/api/reports-service/preference-card/getPreferenceCardsToBeAssigned'
import { useAssignPrefCardToSurgery } from 'lib/services/api/reports-service/preference-card/assignPrefCardToSurgery'
import { queryClient } from 'lib/services/config/query-client-config'

// Other
import { enqueueSnackbar } from 'notistack'

export const useAssignCardModalLogic = ({
  onClose,
  onCreateNew,
  data,
}: AssignCardModalProps) => {
  const [assigningCardId, setAssigningCardId] = useState<string | null>(null)
  const [searchModalCards, setSearchModalCards] = useState('')

  const { surgeonId, surgeryId, surgeonFirstName, surgeonLastName } = data
  const surgeonName = `${surgeonFirstName} ${surgeonLastName}`
  const { data: preferenceCards, isLoading } =
    useGetPreferenceCardsToBeAssigned({
      surgeonId: surgeonId,
      surgeryId: surgeryId,
      searchName: searchModalCards,
    })

  const { mutateAsync: assignPrefCardToSurgery, isLoading: isAssigning } =
    useAssignPrefCardToSurgery()

  const handleAssign = async (cardId: string) => {
    setAssigningCardId(cardId)
    handleAssignCard(cardId)
  }

  const prefCards = [
    ...(preferenceCards?.surgeon_preference_cards ?? []),
    ...(preferenceCards?.other_preference_cards ?? []),
  ]

  const filteredCards = prefCards?.filter(
    (card) =>
      card.surgeon?.firstName
        ?.toLowerCase()
        .includes(searchModalCards.toLowerCase()) ||
      card.surgeon?.lastName
        ?.toLowerCase()
        .includes(searchModalCards.toLowerCase()) ||
      card?.procedure_type
        ?.toLowerCase()
        .includes(searchModalCards.toLowerCase()) ||
      card.name?.toLowerCase().includes(searchModalCards.toLowerCase())
  )

  const handleAssignCard = async (cardId: string) => {
    if (!surgeryId) return

    try {
      await assignPrefCardToSurgery({
        surgery_id: surgeryId,
        id: cardId,
      })
      queryClient.refetchQueries('surgeries')
      onClose()
      enqueueSnackbar('Preference card assigned successfully.', {
        variant: 'success',
      })
    } catch (error) {
      console.error(error)
      enqueueSnackbar('Failed to assign preference card.', {
        variant: 'error',
      })
    }
  }

  return {
    handleAssign,
    handleAssignCard,
    filteredCards,
    isLoading,
    isAssigning,
    searchModalCards,
    setSearchModalCards,
    assigningCardId,
    onCreateNew,
    onClose,
    surgeonName,
  }
}